import { cn } from '@core/utils';

type DividerVariant = 'normal' | 'thick' | 'vertical';

interface DividerProps {
  variant?: DividerVariant;
  className?: string;
}

export const Divider = ({ variant = 'normal', className }: DividerProps) => {
  return (
    <div
      aria-orientation={variant === 'vertical' ? 'vertical' : 'horizontal'}
      className={cn(
        'bg-Gray-200',
        {
          'h-1 w-full': variant === 'normal',
          'h-12 w-full': variant === 'thick',
          'h-full w-1': variant === 'vertical',
        },
        className,
      )}
      role="separator"
    />
  );
};
